import React, { useEffect, useState } from 'react';
import img1 from './Assets/img-min/logo/logo1.png';
import img2 from './Assets/img-min/logo/logo1-light.png';
import { NavLink, Link } from 'react-router-dom';
function Header() {
    MyNavigation();
    return (
        <header>
            <nav className="main-nav navbar navbar-expand-lg hover-navbar dark-to-light fixed-top navbar-dark">
                <div className="container">
                    <NavLink className="navbar-brand main-logo" to="/">
                        <img className="logo-light" src={img2} alt="LOGO" />
                        <img className="logo-dark" src={img1} alt="LOGO" />
                        <p style={{ marginTop: 38, fontSize: 17, display: 'none' }}>Viable Informatics Clues</p>
                    </NavLink>


                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo" aria-controls="navbarTogglerDemo" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>


                    <div className="collapse navbar-collapse" id="navbarTogglerDemo">
                        <ul className="navbar-nav ms-auto mt-2 mt-lg-0">
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link" to="/">HOME</NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link" to="/About">ABOUT</NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link" to="/Services">SERVICES</NavLink>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link" to="/Portfolio">PORTFOLIO</NavLink>
                            </li>                                                      
                            <li className="nav-item dropdown">
                                <NavLink id="navbarmd" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false" to='/TermsAndCondition'>POLICY</NavLink>

                                <div className="dropdown-menu dropdown-menu-md dropdown-menu-lg-center p-4" aria-labelledby="navbarmd">
                                    <div className="list-group list-group-flush">
                                        <div className="list-group-item dropdown-item bg-tansparent d-flex align-item-center">
                                            <div className="align-self-center text-primary">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512"><path stroke="currentColor" d="M416,221.25V416a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V96a48,48,0,0,1,48-48h98.75a32,32,0,0,1,22.62,9.37L406.63,198.63A32,32,0,0,1,416,221.25Z" style={{ fill: 'none', strokeLinejoin: 'round', strokeWidth: 32 }}></path><path stroke="currentColor" d="M256,56V176a32,32,0,0,0,32,32H408" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></path><line stroke="currentColor" x1="176" y1="288" x2="336" y2="288" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></line><line stroke="currentColor" x1="176" y1="368" x2="336" y2="368" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></line></svg>
                                            </div>


                                            <div className="ms-4 align-self-center">
                                                <Link className="text-uppercase mb-1" to='/TermsAndCondition'>
                                                    TERMS & CONDITIONS
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="list-group-item dropdown-item bg-tansparent d-flex align-item-center">
                                            <div className="align-self-center text-primary">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512"><rect stroke="currentColor" x="48" y="48" width="176" height="176" rx="20" ry="20" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></rect><rect stroke="currentColor" x="288" y="48" width="176" height="176" rx="20" ry="20" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></rect><rect stroke="currentColor" x="48" y="288" width="176" height="176" rx="20" ry="20" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></rect><rect stroke="currentColor" x="288" y="288" width="176" height="176" rx="20" ry="20" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></rect></svg>
                                            </div>

                                            <div className="ms-4 align-self-center">
                                                <Link className="text-uppercase mb-1" to='/RefundPolicy'>
                                                    REFUND POLICY
                                                </Link>
                                            </div>

                                        </div>
                                        <div className="list-group-item dropdown-item bg-tansparent d-flex align-item-center">
                                            <div className="align-self-center text-primary">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512"><polyline stroke="currentColor" points="160 368 32 256 160 144" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></polyline><polyline stroke="currentColor" points="352 368 480 256 352 144" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></polyline><line stroke="currentColor" x1="304" y1="96" x2="208" y2="416" style={{ fill: 'none', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 32 }}></line></svg>
                                            </div>

                                            <div className="ms-4 align-self-center">
                                                <Link className="text-uppercase mb-1" to='/PrivacyPolicy'>
                                                    PRIVACY POLICY
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item dropdown">
                                <NavLink className="nav-link" to="/Contact">CONTACT</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    )
}
export default Header;
const MyNavigation = () => {
    const [scrollPos, setScrollPos] = useState(0);
    const [navDark, setNavDark] = useState(null);
    const [navLight, setNavLight] = useState(null);
    const [navOne, setNavOne] = useState(null);
    // const [headerOffset, setHeaderOffset] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollPos(window.scrollY || document.documentElement.scrollTop);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        setNavDark(document.querySelector(".dark-to-light"));
        setNavLight(document.querySelector(".light-to-dark"));
        setNavOne(document.querySelector(".main-nav"));
    }, []);

    useEffect(() => {
        const navCustom = () => {
            const add_class_on_scroll = () => {
                navDark.classList.add("navbar-scrolled", "navbar-light-dark");
                navDark.classList.remove("navbar-dark");
            };

            const remove_class_on_scroll = () => {
                navDark.classList.remove("navbar-scrolled", "navbar-light-dark");
                navDark.classList.add("navbar-dark");
            };

            if (navDark !== null) {
                const navDarkHeight = navDark.offsetHeight;
                if (scrollPos >= navDarkHeight) {
                    add_class_on_scroll();
                } else {
                    remove_class_on_scroll();
                }
            }
        };

        const navCustom2 = () => {
            const add_class_on_scroll2 = () => {
                navLight.classList.add("navbar-scrolled", "navbar-dark-light");
                navLight.classList.remove("navbar-light");
            };

            const remove_class_on_scroll2 = () => {
                navLight.classList.remove("navbar-scrolled", "navbar-dark-light");
                navLight.classList.add("navbar-light");
            };

            if (navLight !== null) {
                const navLightHeight = navLight.offsetHeight;
                if (scrollPos >= navLightHeight) {
                    add_class_on_scroll2();
                } else {
                    remove_class_on_scroll2();
                }
            }
        };

        const navCustom3 = () => {
            const add_class_on_scroll3 = () => {
                navOne.classList.add("navbar-scrolled");
            };

            const remove_class_on_scroll3 = () => {
                navOne.classList.remove("navbar-scrolled");
            };

            if (navOne !== null) {
                const navOneHeight = navOne.offsetHeight;
                if (scrollPos >= navOneHeight) {
                    add_class_on_scroll3();
                } else {
                    remove_class_on_scroll3();
                }
            }
        };

        if (navDark !== null) {
            navCustom();
        } else if (navLight !== null) {
            navCustom2();
        } else if (navOne !== null) {
            navCustom3();
        }
    }, [scrollPos, navDark, navLight, navOne]);

    return null; // Replace null with your JSX for rendering
};